import AddKml from "../components/setting/kml/AddKml";

const AddKmlPage = () =>{

    return(
        <AddKml/>
    )
}
export default AddKmlPage;